var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-fab-transition',[_c('v-btn',{staticClass:"primary floatingButton",attrs:{"absolute":"","bottom":"","right":"","fab":""},on:{"click":function($event){return _vm.go('CategoriesCliente')}}},[_c('v-icon',[_vm._v("mdi-plus")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }